export function combineGetState(
  interactors = {},
  keys = Object.keys(interactors)
) {
  return () =>
    keys.reduce(
      (acc, key) => ({
        ...acc,
        [key]: interactors[key]?.getState?.(),
      }),
      {}
    );
}

export function combineSubscriptions(
  interactors = {},
  keys = Object.keys(interactors)
) {
  const getState = combineGetState(interactors, keys);

  function subscribe(fn) {
    const unsubscribes = [];

    function handler() {
      const state = getState();
      fn(state);
    }

    keys.forEach((key) => {
      if (interactors[key]?.subscribe) {
        unsubscribes.push(interactors[key].subscribe(handler));
      }
    });

    return () => {
      unsubscribes.forEach((unsub) => unsub && unsub());
    };
  }

  return {
    subscribe,
    connect: (fn) => {
      const state = getState();
      fn(state);
      return subscribe(fn);
    },
  };
}

export function combineActions(
  interactors = {},
  keys = Object.keys(interactors)
) {
  return keys.reduce(
    (actions, key) => ({
      ...actions,
      [key]: interactors[key].actions,
    }),
    {}
  );
}

export function combineSelectors(interactors = {}, keys) {
  return keys.reduce(
    (selectors, key) => ({
      ...selectors,
      [key]: interactors[key].selectors,
    }),
    {}
  );
}

export function combineDestroys(
  interactors = {},
  keys = Object.keys(interactors)
) {
  return () => keys.map((key) => interactors[key].destroy());
}

export function combineInteractors(
  interactors = {},
  keys = Object.keys(interactors)
) {
  return {
    ...combineSubscriptions(interactors, keys),
    selectors: combineSelectors(interactors, keys),
    actions: combineActions(interactors, keys),
    destroy: combineDestroys(interactors, keys),
    getState: combineGetState(interactors, keys),
  };
}
